import { createSlice } from "@reduxjs/toolkit";
import {
  getSingleOrder,
  getWebOrder,
} from "../../reduxApi/website/OrdersReduxApi";

const orderSlice = createSlice({
  name: "order",
  initialState: {
    status: "idle",
    order: [],
    SingleOrder: [],
  },
  reducers: {
    deleteorderAction: (state, action) => {
      state.order = state.order.filter(
        (item) => !action.payload.includes(item?.order?.ROWID)
      );
    },
    updateorderAction: (state, action) => {
      const index = state.order.findIndex(
        (item) => item.order.ROWID === action.payload.ROWID
      );
      if (index !== -1) {
        state.order[index] = { order: action.payload };
      }
    },
    addorderAction: (state, action) => {
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID;
      state.order.unshift(temp);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebOrder.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getWebOrder.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.order = action.payload.data.orders;
      })
      .addCase(getSingleOrder.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SingleOrder = action.payload.data.order;
      });
  },
});

export const { deleteorderAction, updateorderAction, addorderAction } =
  orderSlice.actions;
export default orderSlice.reducer;
